import log from 'salvo-lite/log'
import HTML5Video from '../helpers/HTML5Video'

class VideoContainer {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._video = new HTML5Video(this._elem.querySelector('[data-video]'))
        this._controlsContainer = this._elem.querySelector('[data-controls-container]')
        this._playPause = this._elem.querySelector('[data-play-pause]')
        if (this._controlsContainer) {
            this._progress = this._controlsContainer.querySelector('[data-progress]')
            this._progressContainer = this._controlsContainer.querySelector('[data-progress-container]')
            this._mute = this._controlsContainer.querySelector('[data-mute]')
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating')

        this._elem.addEventListener('click', e => {
            e.preventDefault()
            if (e.target !== this._elem) return false

            if (this._video.isPaused()) {
                this._video.play()
            } else {
                this._video.pause()
            }
        })

        if (this._video.getElem().hasAttribute('no-mobile-autoplay') && window.innerWidth <= 768) {
            this._video.load()
            this._video.getElem().pause()
            this._video.getElem().removeAttribute('autoplay')
        }

        if (this._video.getElem().hasAttribute('autoplay')) {
            this._video.play()
            this._elem.classList.add('video-is-playing')
            this._elem.classList.add('video-been-played')
        }

        this._video.listen('play', e => {
            this._elem.classList.add('video-is-playing')
            this._elem.classList.add('video-been-played')
        })

        this._video.listen('pause', e => {
            this._elem.classList.remove('video-is-playing')
        })

        if (this._playPause) {
            this._playPause.addEventListener('click', e => {
                if (this._video.isPaused() || this._video.hasEnded()) {
                    this._video.play()
                } else {
                    this._video.pause()
                }
            })

            this._video.listen('play', e => {
                this._playPause.setAttribute('data-state', 'play')
            })

            this._video.listen('pause', e => {
                this._playPause.setAttribute('data-state', 'pause')
            })
        }

        if (this._controlsContainer) {
            let supportsProgress = (document.createElement('progress').max !== undefined)
            if (!supportsProgress) this._progress.setAttribute('data-state', 'fake')

            this._video.listen('loadedmetadata', () => {
                this._progress.setAttribute('max', this._video.getDuration())
            })

            this._video.listen('update', () => {
                if (!this._progress.getAttribute('max')) this._progress.setAttribute('max', this._video.getDuration())
                this._progress.value = this._video.getCurrentTime()
                this._progress.querySelector('span').style.width = Math.floor((this._video.getCurrentTime() / this._video.getDuration()) * 100) + '%'
            })

            if (this._mute) {
                this._mute.addEventListener('click', e => {
                    this._video.toggleMute()
                    this._mute.setAttribute('data-state', this._video.isMuted() ? 'unmute' : 'mute')
                })
            }

            this._progressContainer.addEventListener('click', e => {
                let pos = (e.pageX - this._progress.getBoundingClientRect().left) / this._progress.offsetWidth
                this._video.setCurrentTime(pos * this._video.getDuration())
            })
        }

        this._video.listen('ended', e => {
            if (!this._video.getElem().hasAttribute('loop')) {
                this._elem.classList.remove('video-is-playing')
                this._elem.classList.remove('video-been-played')
                this._video.load()
            }
        })

        log.debug(this.constructor.name, 'Initiated')
    }
}

export default VideoContainer



// WEBPACK FOOTER //
// ./src/resources/scripts/components/VideoContainer.js